import { useQuery } from "react-query";
import { getFolderPath } from "../../../../actions/Utilities/ScriptConfiguration";

export default function useGetFolderPath() {
  return useQuery("GetFolderPath", getFolderPath, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
}
